export enum Features {
  AUTH = 'auth'
}
